import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer p-10 bg-black text-white">
            <div>
                <span style={{ color: 'red' }} className="font-bold text-xl mt-5">Address</span>
                <p className='text-base mb-4'>High profile Building, 1/A,
                    <br /> Gulistan Road, <br />
                    Church St, Gulistan,<br />
                    Dhaka 560001
                </p>
                <span style={{ color: 'red' }} className="font-bold text-xl">Email</span>
                <p className='text-base mb-4'>info@artsylens.co.in</p>
                <span style={{ color: 'red' }} className="font-bold text-xl">Phone</span>
                <p className='text-base mb-4'>++09611990301</p>
            </div>
            <div className='mx-0 px-0'>
                <span style={{ color: 'red' }} className="font-bold text-xl mt-5 inline-block text-center w-full">Fill up</span>
                <div className="hero mx-0 px-0">
                    <div className="lg:w-96 hero-content flex-col lg:flex-row-reverse w-full">
                        <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
                            <div className="card-body">
                                <div className="form-control">
                                    <label className="label">
                                        <span className="label-text">Your Name</span>
                                    </label>
                                    <input type="text" placeholder="Your name" className="input input-bordered" />
                                </div>
                                <div className="form-control">
                                    <label className="label">
                                        <span className="label-text">Your Email</span>
                                    </label>
                                    <input type="text" placeholder="Your Email" className="input input-bordered" />
                                </div>
                                <div className="form-control">
                                    <label className="label">
                                        <span className="label-text">Your Phone</span>
                                    </label>
                                    <input type="text" placeholder="Your Phone" className="input input-bordered" />
                                </div>
                                <label className="label">
                                        <span className="label-text">Message</span>
                                    </label>
                                <textarea className="textarea textarea-bordered" placeholder="Message"></textarea>
                                <div className="form-control mt-6">
                                    <button className="btn btn-primary">Send Message</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <span style={{ color: 'red' }} className="font-bold text-xl mt-5">Follow Here</span>
                <Link className="link link-hover text-base">Facebook</Link>
                <Link className="link link-hover text-base">Youtube</Link>
                <Link className="link link-hover text-base">Twitter</Link>
                <Link className="link link-hover text-base">Instagram</Link>

                <span style={{ color: 'red' }} className="font-bold text-xl mt-5">Importants</span>
                <Link className="link link-hover text-base">Terms of use</Link>
                <Link className="link link-hover text-base">Privacy policy</Link>
                <Link className="link link-hover text-base">Cookie policy</Link>
            </div>
        </footer>
    );
};

export default Footer;